export default class ExpertController {
  /* @ngInject */
  constructor($stateParams, DictionaryService, NavigationService,
    $anchorScroll, ExpertService, $log, ConfigurationService,
    $state, ProductLinkService) {
    const expertId = $stateParams.expertID;

    this.DictionaryService = DictionaryService;
    this.NavigationService = NavigationService;
    this.$anchorScroll = $anchorScroll;
    this.$log = $log;
    this.authorable = ConfigurationService.getConfiguration();
    this.$state = $state;
    this.isProductLink = ProductLinkService.getProductLinkVerification();
    ExpertService
      .getExpert(expertId)
      .then((expert) => {
        this.expert = expert;
      });
  }

  $onInit() {
    this.$anchorScroll();
  }

  expertTypeLookup(type) {
    return this.DictionaryService.expertTypeLookup(type);
  }

  solutionLookup(solution, targetKey) {
    return this.DictionaryService.solutionDictionaryLookup(solution, targetKey);
  }

  industryLookup(industryKey) {
    return this.DictionaryService.industryLookup(industryKey);
  }

  returnToResultsPage() {
    this.NavigationService.navigateToSearchResults();
  }

  gotoExpertContact() {
    this.$state
      .go('root.contact-expert', { expertID: this.expert.id, isProductLink: this.isProductLink });
  }
}



// WEBPACK FOOTER //
// ./src/containers/expert/expert.controller.js